import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSponsorGroup from './sponsor-group.reducer';

export const selectSponsorGroupState = createFeatureSelector<fromSponsorGroup.State>(
  fromSponsorGroup.sponsorGroupFeatureKey
);

export const selectSponsorGroupList = createSelector(
  selectSponsorGroupState,
  (state: fromSponsorGroup.State) => {
    return _.map(state.entities, entity => entity);
  }
);

export const selectSponsorGroup = (id) => createSelector(
  selectSponsorGroupList,
  (entities: any[]) => {
    return _.find(entities, (entity) => {
      return entity.id == id;
    });
  }
);
